import { render } from "./RGBLed.vue?vue&type=template&id=b5498e2a&scoped=true"
import script from "./RGBLed.vue?vue&type=script&lang=js"
export * from "./RGBLed.vue?vue&type=script&lang=js"

import "./RGBLed.vue?vue&type=style&index=0&id=b5498e2a&lang=scss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5498e2a"]])

export default __exports__